/* eslint-disable react/prop-types */
import { useState } from 'react';

export default function Avatar({ src, name, size = 38 }) {
  const [broken, setBroken] = useState(false);
  const initial = (name || 'L').trim().slice(0, 1).toUpperCase();
  return (
    <span
      className="inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-container font-bold text-umber"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
      title={name}
    >
      {src && !broken ? <img className="h-full w-full object-cover" src={src} alt="" onError={() => setBroken(true)} /> : initial}
    </span>
  );
}
